import React from "react";
import styles from "./styles/Contact.module.css";
import Header from "../../shared/Header/Header";
import Footer from "../../shared/Footer/Footer";
import ContactHero from "./ContactHero";
import ContactForm from "./ContactForm";
import ContactLocation from "./ContactLocation";

export default function Contact() {
  return (
    <div className={styles.page}>
      <Header />
      <main>
        <ContactHero />
        <section className={styles.content}>
          <div className={styles.container}>
            <div className={styles.grid}>
              <ContactForm />
              <ContactLocation />
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
